import { render, staticRenderFns } from "./tablo.vue?vue&type=template&id=725990af&"
import script from "./tablo.vue?vue&type=script&lang=js&"
export * from "./tablo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports